"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GroupFormatter;

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _react = _interopRequireDefault(require("react"));

var _Collaborator = require("./Collaborator");

var _LinkToRecord = _interopRequireDefault(require("./LinkToRecord"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var groupCellContent = {
  outline: "none",
  display: "flex",
  alignItems: "center",
  position: "relative",
  height: "100%",
  borderLeft: "1px solid var(--border-color)",
  paddingLeft: "10px",
  marginLeft: "-0.5px"
};
var groupCellTitle = {
  fontSize: "10px",
  position: "absolute",
  top: "-12px",
  left: "30px",
  color: "gray"
};
var groupCellValue = {
  fontSize: "13px",
  position: "absolute",
  top: "6px",
  left: "30px"
};
var groupCellContentClassname = "rdg-group-cell-content";

function GroupFormatter(_ref) {
  var _childRows$;

  var groupKey = _ref.groupKey,
      isExpanded = _ref.isExpanded,
      toggleGroup = _ref.toggleGroup,
      groupColumn = _ref.groupColumn,
      childRows = _ref.childRows;

  function handleKeyDown(_ref2) {
    var key = _ref2.key;

    if (key === "Enter") {
      toggleGroup();
    }
  }

  var type = groupColumn === null || groupColumn === void 0 ? void 0 : groupColumn.type;
  var d = isExpanded ? "M0.71 1.71L3.3 4.3C3.69 4.69 4.32 4.69 4.71 4.3L7.3 1.71C7.93 1.08 7.48 0 6.59 0H1.41C0.52 0 0.08 1.08 0.71 1.71Z" : "M7.29 3.29L4.7 0.7C4.31 0.31 3.68 0.31 3.29 0.7L0.7 3.29C0.0699998 3.92 0.52 5 1.41 5L6.59 5C7.48 5 7.92 3.92 7.29 3.29Z";
  var content = groupKey === "undefined" || groupKey === "null" ? "" : groupKey;
  var value = childRows === null || childRows === void 0 ? void 0 : (_childRows$ = childRows[0]) === null || _childRows$ === void 0 ? void 0 : _childRows$[groupColumn === null || groupColumn === void 0 ? void 0 : groupColumn.key];

  if (type === "singleSelect") {
    content = value ? /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
      size: "small",
      color: "primary",
      label: value === null || value === void 0 ? void 0 : value.value
    }) : "";
  }

  if (type === "multiSelect") {
    content = Array.isArray(value) ? value.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
        key: index,
        size: "small",
        color: "primary",
        label: item === null || item === void 0 ? void 0 : item.value
      });
    }) : "";
  }

  if (type === "collaborator") {
    content = Array.isArray(value) ? value.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Collaborator.CollaboratorItem, {
        key: index,
        data: item
      });
    }) : "";
  }

  if (type === "createdBy" || type === "updatedBy") {
    content = value ? /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: 8
      }
    }, /*#__PURE__*/_react["default"].createElement(_Collaborator.CollaboratorItem, {
      data: value
    })) : "";
  }

  var renderContent = function renderContent() {
    try {
      if (JSON.parse(content)) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            paddingTop: 10
          }
        }, /*#__PURE__*/_react["default"].createElement(_LinkToRecord["default"], {
          row: _objectSpread(_objectSpread({}, childRows === null || childRows === void 0 ? void 0 : childRows[0]), {}, {
            key: groupColumn.name
          }),
          column: groupColumn
        }));
      }
    } catch (error) {
      return content;
    }
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react["default"].createElement("div", {
      className: groupCellContentClassname,
      tabIndex: -1,
      onKeyDown: handleKeyDown,
      style: groupCellContent
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      onClick: toggleGroup,
      width: "8",
      height: "5",
      viewBox: "0 0 8 5",
      fill: "none",
      "aria-hidden": true,
      style: {
        marginRight: 12,
        cursor: "pointer"
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: d,
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("span", {
      style: groupCellTitle
    }, groupColumn === null || groupColumn === void 0 ? void 0 : groupColumn.name), /*#__PURE__*/_react["default"].createElement("span", {
      style: groupCellValue
    }, renderContent()))
  );
}